import { viewsetDuck } from '@/shared/ducks/viewsetDuck';

export const DEFAULT_STATE = {};

export const duck = viewsetDuck('scheduledShipments', '/api/scheduled-shipments/');

export const usePreviewOrdersAPI = (uid) => {
    return duck.useAPI(`/${uid}/preview-orders/`, { suspense: false });
};

export const { actionTypes, actions, reducer, useAPI, useList, useObject } = duck;

export default duck;
